import {
  ONBOARDING_ZIP_LS_KEY,
  ONBOARDING_PHONE_LS_KEY,
} from '@constants/index';
import { useOnboardingStore } from '@features/onboarding/store/onboarding';

export const clearOnboardingContactData = () => {
  localStorage.removeItem(ONBOARDING_ZIP_LS_KEY);
  localStorage.removeItem(ONBOARDING_PHONE_LS_KEY);
  useOnboardingStore.getState().resetData();
};
